<template>
  <div class="points-records">
    <el-card>
      <div slot="header" class="card-header">
        <span>积分记录</span>
      </div>

      <el-form :inline="true" :model="query" class="filter-form">
        <el-form-item label="openid">
          <el-input
            v-model="query.openid"
            placeholder="按 openid 筛选"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="query.type" placeholder="全部" clearable size="small">
            <el-option :value="1" label="每日浏览" />
            <el-option :value="2" label="分享商品" />
            <el-option :value="3" label="发布商品" />
            <el-option :value="4" label="恶意发布" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="fetchList(1)">查询</el-button>
          <el-button size="small" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="openid" label="openid" min-width="180" />
        <el-table-column prop="points" label="积分" width="80" />
        <el-table-column prop="typeText" label="类型" width="120" />
        <el-table-column prop="created_at" label="创建时间" min-width="180" />
      </el-table>

      <div class="pager">
        <el-pagination
          background
          layout="sizes, prev, pager, next, jumper"
          :page-size="size"
          :page-sizes="[5, 10, 20, 50]"
          :current-page.sync="page"
          :total="total"
          @current-change="fetchList"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import http from '@/utils/http'

function formatDateTime (value) {
  if (!value) return ''
  if (Array.isArray(value) && value.length >= 3) {
    const [y, M, d, h = 0, m = 0, s = 0] = value
    const pad = n => (n < 10 ? '0' + n : '' + n)
    return `${y}-${pad(M)}-${pad(d)} ${pad(h)}:${pad(m)}:${pad(s)}`
  }
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return typeof value === 'string' ? value : ''
  const pad = n => (n < 10 ? '0' + n : '' + n)
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

function typeText (type) {
  if (type === 1) return '每日浏览'
  if (type === 2) return '分享商品'
  if (type === 3) return '发布商品'
  if (type === 4) return '恶意发布'
  return type == null ? '' : `${type}`
}

function toViewRecord (item) {
  return {
    id: item.id,
    openid: item.openid,
    points: item.points,
    type: item.type,
    typeText: typeText(item.type),
    created_at: formatDateTime(item.createdAt || item.created_at)
  }
}

export default {
  name: 'UserPointsRecords',
  data () {
    return {
      loading: false,
      list: [],
      page: 1,
      size: 10,
      total: 0,
      query: {
        openid: '',
        type: null
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList (page = this.page) {
      this.page = page
      this.loading = true
      try {
        const res = await http.get('/api/user-points-records/page', {
          params: {
            page: this.page,
            size: this.size,
            openid: this.query.openid || undefined,
            type: this.query.type == null ? undefined : this.query.type
          }
        })

        let items = []
        let total = 0

        const dataObj = res && res.data ? res.data : res
        let payload = dataObj
        if (payload && typeof payload === 'object' && 'data' in payload && !Array.isArray(payload)) {
          payload = payload.data
        }

        if (Array.isArray(payload)) {
          items = payload
          total = payload.length
        } else if (payload && typeof payload === 'object') {
          const records = payload.records || payload.items || payload.list || []
          items = Array.isArray(records) ? records : []
          total = payload.total != null ? payload.total
            : (payload.totalCount != null ? payload.totalCount
              : (payload.count != null ? payload.count
                : (payload.pages != null ? payload.pages * this.size
                  : items.length)))
        }

        this.list = items.map(toViewRecord)
        this.total = total
      } catch (e) {
        this.$message.error(e.message || '获取积分记录失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (val) {
      this.size = val
      this.fetchList(1)
    },
    resetQuery () {
      this.query.openid = ''
      this.query.type = null
      this.fetchList(1)
    }
  }
}
</script>

<style scoped>
.points-records {
  min-height: 300px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-form {
  margin-bottom: 10px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}
</style>

